import s from './GuestPhoto.module.scss';

export default function GuestPhoto({ src, alt }) {
  return <div className={s.wrapper}>{src && <img src={src} alt={alt} />}</div>;
}
